import { getElementParentRow } from "../../../utils/formHelpers";
import { mapCountryCodeToName } from "../countryCodeMap";
import { wfetch } from "../../../utils/fetch";
 
const GEO_COUNTRY_ENABLED = true;

const getGeoCountry = async (testIP = null) => {
    try {
        const geoEndpoint = "/.rest/geo/v1";

        const fetchOptions = {};

        if (testIP) {
            fetchOptions.headers = {
                "X-Forwarded-For": testIP,
            };
        }

        const response = await wfetch(geoEndpoint, fetchOptions);

        if (response.data && response.data.country) {
            return response.data.country;
        }

        return null;
    } catch {
        return null;
    }
};

// Test IP addresses for geo endpoint testing
// Set to null for production, or use one of the test IPs:
// EU - Germany: "88.198.123.45"
// China: "223.5.5.5"
// Vietnam: "14.160.32.1"
// US: "8.8.8.8"
// Africa: "41.21.64.0"
const TEST_MODE = false;
const TEST_IP = "8.8.8.8";

/**
 * Sets the country field in Marketo embedded form based on geo location
 * @param {Object} form - Marketo form object
 */
const setGeoCountry = async (form) => {
    try {
        if (!GEO_COUNTRY_ENABLED) return null;

        const currentCountry = form.vals().Country;
        const formElement = form.getFormElem()[0];

        const countryFieldElement = formElement.querySelector('select[name="Country"], select#Country');

        if (!currentCountry) {
            const testIp = TEST_MODE ? TEST_IP : null;
            const countryCode = await getGeoCountry(testIp);

            if (countryCode) {
                const countryName = mapCountryCodeToName(countryCode);

                if (countryName) {
                    form.vals({ Country: countryName });

                    if (countryFieldElement) {
                        const parentField =
                            getElementParentRow(countryFieldElement, "form__field") ||
                            getElementParentRow(countryFieldElement, "mktoFormRow");
                        if (parentField) {
                            parentField.classList.add("form__field--focused");
                        }
                    }
                } else {
                    console.warn("[Marketo] Geo country mapping not found for code:", countryCode);
                }
            } else {
                console.warn("[Marketo] Geo country not available for embedded form.");
            }
        }
    } catch {
        return null;
    }
};

export default setGeoCountry;
